import { Avatar, Dropdown, Layout, Menu } from 'antd';
import {
  DiffOutlined,
  DisconnectOutlined,
  FormOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ReadOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React, { FC, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import './dashboard-layout.styles.less';
import { ReactComponent as MidLogoSvg } from 'assets/images/layout/mid-logo.svg';
import { ReactComponent as SmallLogoSvg } from 'assets/images/layout/small-logo.svg';
import DashIcon from 'assets/images/sidebar-icon/Dashboard_Inactive.svg';
import OperationsIcon from 'assets/images/sidebar-icon/Operations_Inactive.svg';
import SupportIcon from 'assets/images/sidebar-icon/Support_Inactive.svg';
import InvoiceIcon from 'assets/images/sidebar-icon/Invoice_Inactive.svg';
import { useAuth } from 'hooks/useAuth';
import { logout } from 'redux/authSlice';
import { useAppDispatch } from 'hooks/store';
import { usePendo } from 'hooks/usePendo';

const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

export const DashboardLayout: FC<{ children: any }> = ({ children }) => {
  const { user } = useAuth();
  const dispatch = useAppDispatch();
  const history: any = useHistory();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState('dashboard');

  usePendo(user);

  const toggleSidebar = () => {
    setCollapsed((c) => !c);
  };

  useEffect(() => {
    const getActiveMenu = () => {
      const path = location.pathname;
      if (path.includes('operations-beta')) {
        return 'operations-beta';
      }
      if (path.includes('operations')) {
        return 'operations';
      }
      if (path.includes('support')) {
        return 'support';
      }
      if (path.includes('discounts')) {
        return 'discounts';
      }
      if (path.includes('bills')) {
        return 'bills';
      }
      if (path.includes('payments')) {
        return 'payments';
      }
      if (path.includes('dentists')) {
        return 'dentists';
      }
      if (path.includes('practices')) {
        return 'practices';
      }
      if (path.includes('marketing')) {
        return 'marketing';
      }
      if (path.includes('education-content')) {
        return 'education-content';
      }
      if (path.includes('content')) {
        return 'content';
      }
      if (path.includes('designer')) {
        return 'designer';
      }
      if (path.includes('manufacturer')) {
        return 'manufacturer';
      }
      if (path.includes('specialist')) {
        return 'specialist';
      }
      if (path.includes('groups')) {
        return 'groups';
      }
      return 'dashboard';
    };

    const actMenu = getActiveMenu();
    setActiveMenu(actMenu);
  }, [location]);

  const handleClick = (e: any) => {
    const { key } = e;
    switch (key) {
      case 'designer':
        history?.push('/designer');
        break;
      case 'manufacturer':
        history?.push('/manufacturer');
        break;
      case 'specialist':
        history?.push('/specialist');
        break;
      default:
        break;
    }
  };

  const logoutUser = () => {
    dispatch(logout());
  };

  const menu = (
    <Menu style={{ minWidth: 120 }}>
      <Menu.Item onClick={logoutUser}>Logout</Menu.Item>
    </Menu>
  );

  return (
    <Layout className="layout custom-navbar">
      <Sider className="sidebar shadow-1" trigger={null} collapsible collapsed={collapsed}>
        <div className="mt-3 mb-2 flex justify-content-center">
          {collapsed ? <SmallLogoSvg height="36px" /> : <MidLogoSvg height="36px" />}
        </div>
        <div className="side-nav">
          <Menu
            onClick={handleClick}
            theme="light"
            mode="inline"
            defaultSelectedKeys={[activeMenu]}
            selectedKeys={[activeMenu]}
          >
            <Menu.Item key="dashboard" icon={<img src={DashIcon} alt="" />}>
              <Link to="/">Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="operations" icon={<img src={OperationsIcon} alt="" />}>
              <Link to="/operations">Operations</Link>
            </Menu.Item>
            <Menu.Item key="operations-beta" icon={<img src={OperationsIcon} alt="" />}>
              <Link to="/operations-beta">Operations Beta</Link>
            </Menu.Item>
            <Menu.Item key="discounts" icon={<DisconnectOutlined />}>
              <Link to="/discounts">Discounts</Link>
            </Menu.Item>
            <Menu.Item key="bills" icon={<DiffOutlined />}>
              <Link to="/bills">Bills</Link>
            </Menu.Item>
            <Menu.Item key="payments" icon={<img src={SupportIcon} alt="" />}>
              <Link to="/payments">Payments</Link>
            </Menu.Item>
            <Menu.Item key="dentists" icon={<img src={InvoiceIcon} alt="" />}>
              <Link to="/dentists">Dentists</Link>
            </Menu.Item>
            <Menu.Item key="practices" icon={<UserOutlined />}>
              <Link to="/practices">Practices</Link>
            </Menu.Item>
            <SubMenu
              key="sub1"
              icon={
                <span className="p-mb-1">
                  <img src={InvoiceIcon} alt="" />
                </span>
              }
              title="Third Parties"
            >
              <Menu.Item key="designer">Designers</Menu.Item>
              <Menu.Item key="manufacturer">Manufacturers</Menu.Item>
              <Menu.Item key="specialist">Specialists</Menu.Item>
            </SubMenu>
            <Menu.Item key="education-content" icon={<ReadOutlined />}>
              <Link to="/education-content">Education Content</Link>
            </Menu.Item>
            <Menu.Item key="release-notes" icon={<FormOutlined />}>
              <Link to="/release-notes">Release notes</Link>
            </Menu.Item>
            <Menu.Item key="groups" icon={<TeamOutlined />}>
              <Link to="/groups">Groups</Link>
            </Menu.Item>
          </Menu>
        </div>
      </Sider>
      <Layout className={`site-layout ${collapsed ? 'side-nav-collapsed' : ''}`}>
        <Header className="app-header bg-white fixed pl-5 pr-5" style={{ padding: 0, zIndex: 999 }}>
          <div className="flex justify-content-between">
            <div>
              {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                className: 'trigger',
                onClick: toggleSidebar,
              })}
              <span className="ml-2">{collapsed ? 'Show menu' : 'Hide menu'}</span>
            </div>
            <div>
              <div className="flex align-items-center">
                <Dropdown overlay={menu} trigger={['click']}>
                  <div className="profile cursor-pointer">
                    {user?.profilePic ? (
                      <Avatar size="large" src={user?.profilePic} />
                    ) : (
                      <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
                    )}
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </Header>
        <Content className="content-section ml-5 mr-5">{children}</Content>
      </Layout>
    </Layout>
  );
};
